import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: "261px",
        cursor: "pointer",
    },

    updateText: {
        color: "#00833E",
        fontSize: "20px",
        letterSpacing: 0,
        fontWeight: 500,
        textDecoration: "underline",
        textAlign: "right",
    },
}));

export default useStyles;
